import { GlobalStore } from "../../types/store";

export const getGoalCreationConfig = (state: GlobalStore) => state.goals.config;
